import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function TenkaiMdReportOptionDialog(props) {
    const [outputCost, setOutputCost] = useState(true);
    const [outputComment, setOutputComment] = useState(true);
    const outputLabel = props.outputFormat === 'pdf' ? 'PDF' : 'Excel';

    useEffect(() => {
        if (!props.open) return;
        setOutputCost(true);
        setOutputComment(true);
    }, [props.open]);

    function handleOutput() {
        if (typeof props.onOutput !== 'function') return;
        props.onOutput({ outputCost, outputComment });
    }

    return (
        <Dialog
            open={props.open === true}
            onClose={props.outputting ? undefined : props.onClose}
            fullWidth={true}
            maxWidth="xs"
            aria-labelledby="tenkai-md-report-option-title"
        >
            <DialogTitle id="tenkai-md-report-option-title" style={{ paddingBottom: 8 }}>
                {`MDマップ発行（${outputLabel}）`}
            </DialogTitle>
            <DialogContent dividers={true}>
                <Typography variant="body2" style={{ marginBottom: 8 }}>
                    帳票へ出力する項目を選択してください。
                </Typography>
                <Box display="flex" flexDirection="column">
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={outputCost}
                                onChange={(event) => setOutputCost(event.target.checked)}
                                disabled={props.outputting}
                            />
                        }
                        label="コスト"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={outputComment}
                                onChange={(event) => setOutputComment(event.target.checked)}
                                disabled={props.outputting}
                            />
                        }
                        label="コメント"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} disabled={props.outputting}>
                    キャンセル
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleOutput}
                    disabled={props.outputting}
                >
                    出力
                </Button>
            </DialogActions>
        </Dialog>
    );
}
